import { takeEvery, all, fork, put } from "redux-saga/effects";
import {
  LOGIN_PAGE_SIGNIN,
  LOGIN_PAGE_SIGNUP,
  LOGOUT_USER,
  LOGIN_PAGE_FORGOT_PASSWORD,
  LOGIN_PAGE_RESET_PASSWORD,
  USER_ACTIVATION,
} from "constants/ActionTypes";
import {
  setVerify,
  showMessage,
  setInitUrl,
  resetApp,
  logoutUserResponse,
  hideLoader,
  forgotPasswordSuccess,
  authSuccess
} from "actions";
import axios from "../services/customer";
import { push } from "react-router-redux";
import {isWebview} from "../util/generalFunction";
function* loginPageSignIn(action) {
  
  const isAdmin=localStorage.getItem("isAdmin")
  try {
    const response = yield axios.post("/auth/local/", {
      identifier: action.payload.email,
      password: action.payload.password,
    });
    console.log("LOGINSAGA",isAdmin,isWebview());
    // if(isWebview()){
    //   if(isAdmin != null && isAdmin=="true" && response.data.user.role.type == "business_owner" ){
    //     console.log('Login Admin')
        yield put(setVerify(response.data));
      // }else if(isAdmin == null && response.data.user.role.type == "customer"){
      //   console.log('Login Customer')
      //   yield put(setVerify(response.data));
      // } else {
      //   yield put(showMessage({message: `You are ${response.data.user.role.type}, You can't Login using this Application.`}));
      // }
      

    // }
    // else{
    //   yield put(setVerify(response.data));
    // }
   
  } catch (error) {
    yield put(showMessage(error.response.data));
  }
}

function* loginPageSignUp(action) {
  try {
    const response = yield axios.post("/auth/local/register/", {
      username: action.payload.email,
      email: action.payload.email,
      password: action.payload.password,
      firstname: action.payload.firstname,
      lastname: action.payload.lastname,
      phonenumber: action.payload.phonenumber,
    });
    yield put(hideLoader());
    // yield put(push("/login"));
    if(action.payload.appointmentData != undefined && action.payload.appointmentData != '') {
      yield put(authSuccess({user: response.data.user}));
      yield put(push(`${action.payload.appointmentData.url.split("#")[1]}`))
    } else {
      yield put(authSuccess());
    }
    // yield put(setVerify(response.data));
  } catch (error) {
    console.log("TCL: function*loginPageSignUp -> error", error)
    yield put(showMessage(error.response.data));
  }
}

function* forgotPassword({ payload }) {
  try {
    const response = yield axios.post("/auth/forgot-password/", {
      email: payload.email,
      url: "https://vibo-frontend.herokuapp.com/#/reset-password",
    });
    // yield put(forgotPasswordSuccess(true));
    yield put(hideLoader());

    // console.log("MEGHA",response)
    if (response.status === 200) {
      yield put(forgotPasswordSuccess(true));
    }
    // yield put(push("/login"));
  } catch (error) {
    // console.log("TCL: function*forgotPassword -> error", error)
    yield put(showMessage(error.response.data));
  }
}

function* resetPassword({ payload }) {
  try {
    const response = yield axios.post("/auth/reset-password/", {
      code: payload.code,
      password: payload.password,
      passwordConfirmation: payload.password,
    });
    console.log("TCL: function*forgotPassword -> response", response);
    yield put(hideLoader());
    yield put(setVerify(response.data));
    // yield put(push("/login"));
  } catch (error) {
    // console.log("TCL: function*forgotPassword -> error", error)
    yield put(showMessage(error.response.data));
  }
}

function* logoutPageUser({ payload }) {
  try {
    const response = yield axios.put("/auth/local/", {});
  } catch (error) {
    yield put(showMessage(error.response.data));
  }
}

function* userActivation({ payload }) {
  try {
  const response = yield axios.get(`/auth/email-confirmation?confirmation=${payload}`);
  if(response.data.active == true) {
    // yield put(push("/login"));
    yield put(hideLoader());
    yield put(authSuccess());
  }
  console.log("ACTIVATION", response);
  } catch (error) {
  console.log("Error", error);
  yield put(showMessage(error.response.data));
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(LOGIN_PAGE_SIGNIN, loginPageSignIn),
    takeEvery(LOGIN_PAGE_SIGNUP, loginPageSignUp),
    takeEvery(LOGIN_PAGE_FORGOT_PASSWORD, forgotPassword),
    takeEvery(LOGIN_PAGE_RESET_PASSWORD, resetPassword),
    takeEvery(LOGOUT_USER, logoutPageUser),
    takeEvery(USER_ACTIVATION, userActivation),
  ]);
}



// WEBPACK FOOTER //
// ./sagas/LoginSaga.js